// Possible values for DATA_SET_SCOPE: "ALL", "UNIT", "LEARNING_COURSE"
export const ASSESSMENT_COMMON_PREFERENCE_KEYS = {
  DATA_SET_SCOPE: "dataSetScope",
};

export const LESSON_PLANNING_TRANSITION_PROPS = {
  defaultStyle: {
    transition: "width 0.3s ease-in-out",
    width: "0px",
    display: "flex",
    flex: 1,
  },
  transitionStyles: {
    entered: { width: "100%" },
    exited: { width: "0px" },
  },
  timeout: 0,
  unmountOnExit: true,
  mountOnEnter: true,
};
